export const MOBILE_MENU_VISIBLE = 'MOBILE_MENU_VISIBLE';
export const CLOSE_MOBILE_MENU = 'CLOSE_MOBILE_MENU';
export const STORE_SYSTEM_MESSAGE = 'STORE_SYSTEM_MESSAGE';
export const SET_SYSTEM_MESSAGE = 'SET_SYSTEM_MESSAGE';
export const SET_EMAIL_VERIFICATION = 'SET_EMAIL_VERIFICATION';
export const TOGGLE_SHOP_CATEGORY_MENU = 'TOGGLE_SHOP_CATEGORY_MENU';
